import {RoomState} from '@/api/consts';
import {bookings as impl} from '@/room-booking/impl';

export default {
  namespaced: true,
  getters: {
    roomState(state, getters, rootState, rootGetters) {
      if (rootGetters['hybridOffice/enabled']) {
        return rootGetters['hybridOffice/roomState'];
      }
      const currentMeeting = rootGetters['bookings/currentBooking'];
      if (currentMeeting === null) {
        return RoomState.AVAILABLE;
      }
      const reservationKey = rootGetters['bookings/currentReservationKey'];
      if (!impl.requiresCheckIn(currentMeeting, reservationKey) || impl.hasCheckIn(currentMeeting, reservationKey) ||
          rootGetters['config/readOnlyMode']) {
        return RoomState.OCCUPIED;
      }
      return RoomState.BOOKED;
    },
    roomName(state, getters, rootState, rootGetters) {
      if (rootGetters['hybridOffice/enabled']) {
        return rootGetters['hybridOffice/title'] || '';
      }
      // show the title of the resource that is booked while there is a booking
      return rootGetters['bookings/currentBookingResourceTitle'] || rootGetters['resources/active/title'];
    }
  }
};
